import { Component, OnInit, inject, input, viewChild } from '@angular/core';
import {ButtonModule} from "primeng/button";
import {DataService} from "../../service/data.service";
import {DialogModule} from "primeng/dialog";
import {FileUpload, FileUploadModule} from "primeng/fileupload";
import {MenuItem, MessageService} from "primeng/api";
import {BadgeModule} from "primeng/badge";
import {ProgressService} from "../../service/progress.service";
import mammoth from "mammoth";
import {HtmlToDelta} from "quill-delta-from-html";
import {SplitButtonModule} from "primeng/splitbutton";
import {Project} from "../../api/db/entities/Project";
import {PlatformUser} from "../../api/db/entities/PlatformUser";
import {DocumentService} from "../../service/document.service";
import {ProjectSchemas} from "../../api/project_schemas";
import {DocumentMetadata} from "../contents-management/MetadataBlot";
import {Section} from "../contents-management/SectionBlot";


@Component({
    selector: 'editor-space',
    templateUrl: './editor-space.component.html',
    imports: [
    ButtonModule,
    DialogModule,
    FileUploadModule,
    BadgeModule,
    SplitButtonModule
],
    styleUrl: './editor-space.component.scss'
})
export class EditorSpaceComponent implements OnInit{
    private progressService = inject(ProgressService);
    protected documentService = inject(DocumentService);
    protected dataService = inject(DataService);

    readonly project = input.required<Project>();
    readonly user = input.required<PlatformUser>();

    readonly fileUpload = viewChild<FileUpload>('fileUpload');

    editItems: MenuItem[] = [
        {label: 'Re-Import Document', icon: 'pi pi-upload', command: (x) => {
                this.displayUploader=true
            }}
    ];

    async ngOnInit() {
        //const result = await this.etherpadService.createAuthor('MEEWOM');
        //console.log('CommentComponent: ', result);
    }

    files = [];

    totalSize: number = 0;

    totalSizePercent: number = 0;


    chooseFile(): boolean {
        this.fileUpload().choose();
        return false;
    }



    onRemoveTemplatingFile(event, file, removeFileCallback, index) {
        removeFileCallback(event, index);
        this.totalSize -= parseInt(this.formatSize(file.size));
        this.totalSizePercent = this.totalSize / 10;
    }

    onClearTemplatingUpload() {
        this.fileUpload().clear();
        this.totalSize = 0;
        this.totalSizePercent = 0;
        this.displayUploader = false;
    }

    private cleanUpHTML(inHTML: string): string {
        return inHTML
            .replaceAll('<p></p>','<br/>')
            .replaceAll('</p>','</p><br/>');
    }

    async onTemplatedUpload() {
        this.progressService.blockWithMessage('Converting and Importing File');

        //console.log("FILES: ",this.files[0]);
        const result = await mammoth.convertToHtml({arrayBuffer: await this.files[0].arrayBuffer()}, {
            //Options
                includeDefaultStyleMap: true,
                includeEmbeddedStyleMap: true,
                ignoreEmptyParagraphs: false
        });
        let content = DocumentMetadata.getInitialMetadataHTML(this.project())+
            Section.getInitialSectionHTML(this.project())+
            this.cleanUpHTML(result.value);
        console.log(content);
        const delta = new HtmlToDelta().convert(content);
        await this.documentService.saveInitialDeltaContent(this.project(), delta);
        await this.dataService.saveCoreProject(this.project());
        await this.dataService.setSelectedProject(this.project());
        this.editDocument();
        this.progressService.unBlock();
        //console.log('DELTA RESULT: ', delta);

            //this.dataService.switchToEditLayout();
    }

    onSelectedFiles(event) {
        this.files = event.currentFiles;
        this.files.forEach((file) => {
            this.totalSize += parseInt(this.formatSize(file.size));
        });
        this.totalSizePercent = this.totalSize / 10;
    }

    uploadEvent(callback) {
        callback();
    }

    formatSize(bytes) {
        const k = 1024;
        const dm = 3;
        const sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) {
            return `0 ${sizes[0]}`;
        }

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

        return `${formattedSize} ${sizes[i]}`;
    }

    protected readonly Object = Object;
    protected displayUploader: boolean = false;

    async startNewDocument() {
        const html =  DocumentMetadata.getInitialMetadataHTML(this.project())+
            Section.getInitialSectionHTML(this.project())+
            ProjectSchemas.SCHEMADISPLAY_BY_CODE[this.project().schemaCode].initialContentHTML;
        const delta = new HtmlToDelta().convert(html);
        console.log('New Document: ', html, delta);
        await this.documentService.saveInitialDeltaContent(this.project(), delta);
        await this.dataService.saveCoreProject(this.project());
        await this.dataService.setSelectedProject(this.project());
        //this.editDocument();
    }

    async editDocument() {
        this.dataService.switchToEditLayout();
    }
}
